import { useCursorHandlers } from '../../../contexts/CursorContext/Cursor';
import { alpha, useTheme } from '@mui/material/styles';

export const useEditorHandlers = (name: string) => {
  const theme = useTheme();

  return useCursorHandlers({
    name,
    styles: [
      {
        name: 'theme_component_search_field_input_color',
        label: 'Input text color',
        type: 'color',
        default: theme.palette.text.primary,
      },
      {
        name: 'theme_component_search_field_background_color',
        label: 'Background color',
        type: 'color',
        default: alpha(theme.palette.common.white, 0.15),
      },
      {
        name: 'theme_component_search_field_hover_background_color',
        label: 'Background hover color',
        type: 'color',
        default: alpha(theme.palette.common.white, 0.25),
      },
      {
        name: 'theme_component_search_field_icon_color',
        label: 'Icon color',
        type: 'color',
        default: theme.palette.text.primary,
      },
      {
        name: 'theme_component_search_field_icon_hover_color',
        label: 'Icon hover color',
        type: 'color',
        default: theme.palette.action.hover,
      },
    ],
    configuration: [],
  });
}